import React from "react";

export function ShimmerBar({ className = "" }: { className?: string }) {
  return (
    <div className={`relative overflow-hidden rounded-lg bg-muted ${className}`}>
      <style>{`@keyframes pdshim { 100% { transform: translateX(100%); } }`}</style>
      <div className="absolute inset-0 -translate-x-full animate-[pdshim_1.6s_infinite] bg-gradient-to-r from-transparent via-foreground/10 to-transparent" />
    </div>
  );
}

export function EmptyState({
  icon: Icon,
  title,
  desc,
  cta,
}: {
  icon: React.ComponentType<{ size?: number; className?: string }>;
  title: string;
  desc: string;
  cta?: React.ReactNode;
}) {
  return (
    <div className="mx-auto max-w-md rounded-2xl border border-dashed border-border bg-card/50 p-10 text-center">
      <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-primary-main/10 text-primary-main">
        <Icon size={22} />
      </div>
      <h3 className="mb-2 text-[16px] font-black text-foreground">{title}</h3>
      <p className="mb-5 text-[12.5px] leading-relaxed text-muted-foreground">{desc}</p>
      {cta}
    </div>
  );
}

export function ErrorState({ onRetry }: { onRetry?: () => void }) {
  return (
    <div className="mx-auto max-w-md rounded-2xl border border-error/40 bg-error/5 p-10 text-center">
      <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-error/15 text-error">
        ⚠
      </div>
      <h3 className="mb-2 text-[16px] font-black text-foreground">خطا در بارگذاری</h3>
      <p className="mb-5 text-[12.5px] text-muted-foreground">
        ارتباط با سرور برقرار نشد. لطفاً دوباره تلاش کن.
      </p>
      {onRetry && (
        <button
          onClick={onRetry}
          className="rounded-xl bg-primary-main px-5 py-2.5 text-[12.5px] font-black text-white hover:bg-primary-400"
        >
          تلاش مجدد
        </button>
      )}
    </div>
  );
}
